// extracted by mini-css-extract-plugin
module.exports = {"setDefault":"assessmentList_setDefault__KsTU3","show":"assessmentList_show__PGdm7"};